import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

const GetFavoritesQuery = gql`
  query {
    favorites {
      id
      definition
      product {
        id
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  search?: string;
  categoryId?: string;
  language: string;
}

interface IResponse {
  data: any;
}

@observer
class FavoritesQuery extends React.Component<ChildProps<IInputProps, IResponse>> {
  public render() {
    const favorites = (this.props as any).favorites;
    return this.props.children({
      favorites
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetFavoritesQuery, {
    name: 'favorites'
  })
)(FavoritesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/Favorites.tsx